import api from './api';

const publicService = {
  // Get the active, in-window campaigns for the home page.
  // Pass a placement ('hero' | 'strip' | 'wide' | 'section') to narrow it.
  getCampaigns: async (placement = null) => {
    const params = placement ? { placement } : {};
    const response = await api.get('/public/campaigns', { params });
    return response.data.data.campaigns;
  },

  // Get one campaign plus its hand-picked products, in admin-defined order
  getCampaign: async slug => {
    const response = await api.get(`/public/campaigns/${slug}`);
    return response.data.data;
  },

  // Get featured products
  getFeaturedProducts: async (limit = 8) => {
    const response = await api.get('/public/featured-products', {
      params: { limit },
    });
    return response.data.data.products;
  },

  // Get featured categories
  getFeaturedCategories: async (limit = 4) => {
    const response = await api.get('/public/featured-categories', {
      params: { limit },
    });
    return response.data.data.categories;
  },

  // Get the hand-picked hero product slides (up to a limit). Each slide is a
  // product plus the copy an admin typed to pitch it in the hero.
  getHeroProducts: async (limit = 3) => {
    const response = await api.get('/public/hero-product', {
      params: { limit },
    });
    return response.data.data.heroProducts;
  },

  // Get public support content (contact info + FAQs)
  getSupportContent: async () => {
    const response = await api.get('/public/support');
    return response.data.data;
  },

  // Submit support/contact request
  submitSupportRequest: async payload => {
    const response = await api.post('/public/support/contact', payload);
    return response.data;
  },

  // Get the active hero banner
  getActiveHeroBanner: async () => {
    const response = await api.get('/public/hero-banner');
    return response.data.data.banner;
  },

  // Get a home section's heading + subheading by key
  getHomeSection: async key => {
    const response = await api.get(`/public/home-section/${key}`);
    return response.data.data.section;
  },

  // Search products. An empty `q` returns the most popular products.
  // Returns { products, mode, sort, total, facets }.
  searchProducts: async ({
    q = '',
    limit = 24,
    sort = '',
    category = '',
    minPrice = '',
    maxPrice = '',
  } = {}) => {
    const params = { q, limit };
    if (sort) params.sort = sort;
    if (category) params.category = category;
    if (minPrice !== '') params.min_price = minPrice;
    if (maxPrice !== '') params.max_price = maxPrice;

    const response = await api.get('/public/search', { params });
    return response.data.data;
  },

  // Get the shop's public settings as a typed key/value map
  getSettings: async () => {
    const response = await api.get('/public/settings');
    return response.data.data.settings;
  },
};

export default publicService;
